import { useMemo, useState } from "react";
import { Input, Table } from "reactstrap";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario.js";
import devuelveDependenciaConstultada from "../tools/devuelveDependencia.js";

function ModuloDevuelveCursos(props) {
  const usuario = ObtieneDatosCookies();
  const dependencias = devuelveDependenciaConstultada();

  const [busqueda, setBusqueda] = useState("");
  const [filtroDependencia, setFiltroDependencia] = useState("");
  const [veoListado, setVeoListado] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: "tituloCertificado",
    direction: "asc",
  });

  const normalizarTexto = (valor) =>
    String(valor ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  const obtenerDescripcionDependencia = (destinoCreo) => {
    const dependencia = Array.isArray(dependencias)
      ? dependencias.find(
          (dep) => String(dep.id) === String(destinoCreo)
        )
      : null;

    return dependencia?.descripcion || "Desconocido";
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      }

      return {
        key,
        direction: "asc",
      };
    });
  };

  const sortIcon = (key) => {
    if (sortConfig.key !== key) return "↕";
    return sortConfig.direction === "asc" ? "↑" : "↓";
  };

  const cursosFiltradosYOrdenados = useMemo(() => {
    const cursos = Array.isArray(props.cosas) ? [...props.cosas] : [];
    const textoBusqueda = normalizarTexto(busqueda);

    const filtradosPorDependencia = filtroDependencia
      ? cursos.filter(
          (curso) =>
            String(curso?.destinoCreo) === String(filtroDependencia)
        )
      : cursos;

    const filtradosPorBusqueda = !textoBusqueda
      ? filtradosPorDependencia
      : filtradosPorDependencia.filter((curso) => {
          const contenidoBuscable = [
            curso?.tituloCertificado,
            curso?.nombreCurso,
            curso?.fechaRealizado,
            curso?.organizadoPor,
            curso?.tipoCapacitacion,
            curso?.resolucionCertificado,
            curso?.resolucionJPP,
            curso?.reginterno,
            obtenerDescripcionDependencia(curso?.destinoCreo),
          ]
            .map(normalizarTexto)
            .join(" ");

          return contenidoBuscable.includes(textoBusqueda);
        });

    const { key, direction } = sortConfig;

    if (!key) return filtradosPorBusqueda;

    return filtradosPorBusqueda.sort((a, b) => {
      let valorA;
      let valorB;

      if (key === "creadoDescripcion") {
        valorA = obtenerDescripcionDependencia(a?.destinoCreo);
        valorB = obtenerDescripcionDependencia(b?.destinoCreo);
      } else {
        valorA = a?.[key];
        valorB = b?.[key];
      }

      if (key === "fechaRealizado") {
        const fechaA = new Date(valorA || 0).getTime();
        const fechaB = new Date(valorB || 0).getTime();

        if (!Number.isNaN(fechaA) && !Number.isNaN(fechaB)) {
          return direction === "asc"
            ? fechaA - fechaB
            : fechaB - fechaA;
        }
      }

      const textoA = normalizarTexto(valorA);
      const textoB = normalizarTexto(valorB);

      return direction === "asc"
        ? textoA.localeCompare(textoB, "es", { numeric: true })
        : textoB.localeCompare(textoA, "es", { numeric: true });
    });
  }, [
    props.cosas,
    busqueda,
    filtroDependencia,
    sortConfig,
    dependencias,
  ]);

  const totalCursos = Array.isArray(props.cosas)
    ? props.cosas.length
    : 0;

  const totalMostrados = cursosFiltradosYOrdenados.length;

  const puedeFiltrarDependencia =
    Number(usuario?.destino) === 7 ||
    Number(usuario?.destino) === 1;

  const limpiarFiltros = () => {
    setBusqueda("");
    setFiltroDependencia("");
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        padding: "16px",
        marginTop: "16px",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.10)",
        color: "#212529",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          marginBottom: "14px",
        }}
      >
        <div>
          <h5 style={{ margin: 0, fontWeight: 700 }}>
            Certificaciones encontradas
          </h5>

          <small style={{ color: "#6c757d" }}>
            Mostrando {totalMostrados} de {totalCursos}
          </small>
        </div>

        <button
          type="button"
          className={`btn ${
            veoListado ? "btn-outline-secondary" : "btn-success"
          }`}
          onClick={() => setVeoListado((prev) => !prev)}
        >
          {veoListado ? "Ocultar listado" : "Ver listado"}
        </button>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: puedeFiltrarDependencia
            ? "minmax(250px, 1fr) minmax(250px, 1fr) auto"
            : "minmax(250px, 1fr) auto",
          gap: "10px",
          alignItems: "end",
          marginBottom: "14px",
        }}
      >
        <div>
          <label
            htmlFor="busqueda-certificaciones"
            style={{
              display: "block",
              marginBottom: "5px",
              fontWeight: 600,
            }}
          >
            Buscar
          </label>

          <Input
            id="busqueda-certificaciones"
            type="search"
            value={busqueda}
            onChange={(event) => setBusqueda(event.target.value)}
            placeholder="Curso, fecha, organizador, resolución..."
          />
        </div>

        {puedeFiltrarDependencia && (
          <div>
            <label
              htmlFor="filtro-dependencia-certificaciones"
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: 600,
              }}
            >
              Dependencia
            </label>

            <Input
              id="filtro-dependencia-certificaciones"
              type="select"
              value={filtroDependencia}
              onChange={(event) =>
                setFiltroDependencia(event.target.value)
              }
            >
              <option value="">Todas las dependencias</option>

              {(Array.isArray(dependencias)
                ? dependencias
                : []
              ).map((dependencia) => (
                <option
                  key={dependencia.id}
                  value={dependencia.id}
                >
                  {dependencia.descripcion}
                </option>
              ))}
            </Input>
          </div>
        )}

        {(busqueda || filtroDependencia) && (
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={limpiarFiltros}
          >
            Limpiar
          </button>
        )}
      </div>

      {veoListado && (
        <div
          style={{
            maxHeight: "430px",
            overflowY: "auto",
            borderRadius: "8px",
            border: "1px solid #dee2e6",
          }}
        >
          <Table
            responsive
            bordered
            hover
            size="sm"
            className="align-middle mb-0"
          >
            <thead
              className="table-light"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2,
              }}
            >
              <tr>
                <th
                  style={{
                    width: "55px",
                    textAlign: "center",
                  }}
                >
                  #
                </th>

                <th>
                  <button
                    type="button"
                    className="btn btn-link text-dark text-decoration-none p-0 fw-bold"
                    onClick={() =>
                      handleSort("tituloCertificado")
                    }
                  >
                    Curso{" "}
                    <span style={{ color: "#6c757d" }}>
                      {sortIcon("tituloCertificado")}
                    </span>
                  </button>
                </th>

                <th>
                  <button
                    type="button"
                    className="btn btn-link text-dark text-decoration-none p-0 fw-bold"
                    onClick={() => handleSort("fechaRealizado")}
                  >
                    Fecha{" "}
                    <span style={{ color: "#6c757d" }}>
                      {sortIcon("fechaRealizado")}
                    </span>
                  </button>
                </th>

                <th>
                  <button
                    type="button"
                    className="btn btn-link text-dark text-decoration-none p-0 fw-bold"
                    onClick={() => handleSort("organizadoPor")}
                  >
                    Organizador{" "}
                    <span style={{ color: "#6c757d" }}>
                      {sortIcon("organizadoPor")}
                    </span>
                  </button>
                </th>

                <th>
                  <button
                    type="button"
                    className="btn btn-link text-dark text-decoration-none p-0 fw-bold"
                    onClick={() =>
                      handleSort("creadoDescripcion")
                    }
                  >
                    Creado por{" "}
                    <span style={{ color: "#6c757d" }}>
                      {sortIcon("creadoDescripcion")}
                    </span>
                  </button>
                </th>
              </tr>
            </thead>

            <tbody>
              {cursosFiltradosYOrdenados.length > 0 ? (
                cursosFiltradosYOrdenados.map(
                  (curso, index) => (
                    <tr
                      key={curso?.id ?? `${curso?.nombreCurso}-${index}`}
                      onClick={() => props.myID(curso)}
                      style={{
                        cursor: "pointer",
                      }}
                      title="Seleccionar certificación"
                    >
                      <td className="text-center">{index + 1}</td>

                      <td>
                        <strong>
                          {curso?.tituloCertificado || "-"}
                        </strong>

                        {curso?.nombreCurso && (
                          <div
                            style={{
                              color: "#6c757d",
                              fontSize: "0.8rem",
                            }}
                          >
                            {curso.nombreCurso}
                          </div>
                        )}
                      </td>

                      <td>{curso?.fechaRealizado || "-"}</td>

                      <td>{curso?.organizadoPor || "-"}</td>

                      <td>
                        <span className="badge bg-secondary">
                          {obtenerDescripcionDependencia(
                            curso?.destinoCreo
                          )}
                        </span>
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-4">
                    <strong>
                      No se encontraron certificaciones.
                    </strong>

                    {(busqueda || filtroDependencia) && (
                      <div
                        style={{
                          marginTop: "6px",
                          color: "#6c757d",
                        }}
                      >
                        Probá cambiando los filtros de búsqueda.
                      </div>
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
}

export default ModuloDevuelveCursos;